import { useEffect, useState } from "react";
import { api } from "../api/client.js";
import "../Style/TermsAndConditions.css";

const DEFAULT_TERMS_TEXT = `Terms of Use

Effective Date: July 10, 2026

Welcome to our website uppandaway.com. These Terms of Use govern your access to and use of this Website, including any purchases made through it.

By accessing, browsing, or using this Website, you acknowledge that you have read, understood, and agree to be bound by these Terms. If you do not agree to these Terms, please discontinue use of the Website.

⸻

1. About Our Brand

Our Website presents a collection of handcrafted sculptural home fragrance objects, decorative pieces, and related lifestyle products created in limited quantities.

Unless otherwise stated, all products are intended for personal, non-commercial use.

⸻

2. Eligibility

By using this Website, you represent that you are at least 18 years of age or are using the Website under the supervision of a parent or legal guardian.

You agree to use the Website only for lawful purposes.

⸻

3. Product Availability

Every piece is created in limited production.

Availability is not guaranteed.

Products may be discontinued, modified, or removed without prior notice.

We reserve the right to limit quantities purchased by any customer.

⸻

4. Pricing

Prices are displayed in U.S. Dollars (USD).

Prices may change without prior notice.

Although we strive for accuracy, pricing errors may occasionally occur. We reserve the right to cancel orders resulting from pricing inaccuracies before shipment. If payment has already been processed, a full refund of the incorrect charge will be issued.

⸻

5. Order Acceptance

Submitting an order does not guarantee acceptance.

We reserve the right to refuse, limit, or cancel any order for reasons including, but not limited to:

* suspected fraud
* inaccurate billing information
* suspected resale activity
* product unavailability
* payment authorization failure
* violation of these Terms

If an order is canceled after payment is received, the payment will be refunded to the original payment method.

⸻

6. Payment

Payments are securely processed by trusted third-party payment providers.

We do not store your complete payment card information on our servers.

By submitting payment information, you represent that you are authorized to use the payment method provided.

⸻

7. Shipping

Orders are shipped using reputable carriers, including FedEx and UPS.

Estimated delivery dates are estimates only and are not guaranteed.

Once an order has been transferred to the shipping carrier, delivery timing is outside our reasonable control.

Customers are responsible for providing accurate shipping information.

Additional shipping policies are available in our separate Shipping Policy.

⸻

8. Final Sale

Due to the limited-edition and handcrafted nature of our products, all purchases are considered final.

We do not accept returns, exchanges, or cancellations once an order has been placed.

If your order arrives damaged, defective, or you receive an incorrect item, please contact us within forty-eight (48) hours of delivery and include photographs of both the product and its original packaging. We will review the issue and determine an appropriate resolution in accordance with applicable law.

Nothing in this section limits any rights you may have under applicable consumer protection laws.

⸻

9. Product Variations

Each piece is handcrafted.

Minor differences in color, texture, finish, dimensions, fragrance intensity, natural material characteristics, and artistic details are expected and are not considered defects.

Product photography is intended to represent each item as accurately as possible; however, actual colors may vary depending on your device or display settings.

⸻

10. Product Care and Safety

Customers are responsible for following all care instructions provided with their purchase.

Products should be used only as intended.

Unless specifically indicated otherwise, decorative objects are not toys and should be kept out of reach of children and pets.

Failure to follow safety instructions may result in damage, injury, or reduced product performance.

⸻

11. Intellectual Property

All content available on this Website is the exclusive property of Up and Away or its licensors.

This includes, but is not limited to:

* product designs
* sculptural concepts
* artwork
* illustrations
* photographs
* videos
* graphics
* logos
* icons
* product names
* written descriptions
* collections
* website layout
* branding elements

These materials are protected under United States copyright, trademark, trade dress, and other intellectual property laws.

No portion of this Website may be copied, reproduced, distributed, modified, published, displayed, sold, licensed, or otherwise exploited without prior written permission.

⸻

12. Limited License

You are granted a limited, revocable, non-exclusive license to access and use this Website solely for personal shopping purposes.

This license does not permit:

* commercial use
* data mining
* automated scraping
* copying content
* resale of Website materials
* reverse engineering
* unauthorized reproduction

⸻

13. User Conduct

You agree not to:

* violate applicable laws
* interfere with Website security
* transmit malicious software
* attempt unauthorized access
* disrupt Website operations
* impersonate another individual
* submit false information
* use automated bots without authorization

Violation of these Terms may result in termination of access.

⸻

14. User Submissions

If you submit reviews, photographs, suggestions, comments, testimonials, or other materials to us, you grant us a non-exclusive, worldwide, royalty-free license to use, reproduce, publish, display, adapt, and distribute those materials for business, marketing, and promotional purposes, unless prohibited by law.

You represent that you own or have permission to submit such content.

⸻

15. Third-Party Services

The Website may contain links to third-party services or websites.

We are not responsible for the content, privacy practices, availability, or policies of third-party services.

Your use of third-party websites is governed by their own terms.

⸻

16. Disclaimer

The Website and all products are provided “as is” and “as available” to the fullest extent permitted by law.

Except as expressly required by law, we make no warranties, express or implied, regarding merchantability, fitness for a particular purpose, uninterrupted operation, or error-free performance.

⸻

17. Limitation of Liability

To the fullest extent permitted by applicable law, we shall not be liable for any indirect, incidental, consequential, special, punitive, or exemplary damages arising from or relating to your use of the Website or purchase of our products.

Our total liability for any claim relating to an order shall not exceed the amount actually paid for the applicable product, except where prohibited by law.

Nothing in these Terms limits liability that cannot legally be excluded.

⸻

18. Indemnification

You agree to indemnify and hold harmless Up and Away, its owner, affiliates, contractors, and service providers from claims, damages, liabilities, costs, and expenses arising from your violation of these Terms or misuse of the Website.

⸻

19. Force Majeure

We shall not be liable for delays or failure to perform resulting from events beyond our reasonable control, including but not limited to natural disasters, severe weather, labor disputes, pandemics, transportation interruptions, carrier delays, government actions, power outages, or failures of third-party service providers.

⸻

20. Governing Law

These Terms shall be governed by and interpreted in accordance with the laws of the State of Texas, without regard to conflict-of-law principles.

⸻

21. Dispute Resolution

Before initiating legal proceedings, you agree to first contact us in a good-faith effort to resolve the matter informally.

If a dispute cannot be resolved informally, it shall be resolved in a court of competent jurisdiction located in Texas, unless applicable law requires otherwise.

⸻

22. Changes to These Terms

We reserve the right to update or modify these Terms at any time.

Changes become effective immediately upon publication on the Website.

Your continued use of the Website constitutes acceptance of the revised Terms.

⸻

23. Severability

If any provision of these Terms is determined to be invalid or unenforceable, the remaining provisions shall continue in full force and effect.

⸻

24. Entire Agreement

These Terms, together with our Privacy Policy, Shipping Policy, Accessibility Statement, and any other policies referenced on this Website, constitute the entire agreement between you and Up and Away regarding your use of the Website.

⸻

25. Contact

For questions regarding these Terms of Use or your order, please contact us using the contact information provided on the Website.

Last Updated: July 10, 2026`;

function TermsAndConditions({
  isOpen = true,
  onClose,
  showActions = false,
  acceptText = "Accept",
  denyText = "Deny",
  closeText = "Close",
  onAccept,
  onDeny,
  title = "Terms & Conditions",
  children,
  closeOnBackdrop = true,
  showCloseAction = false,
  showHeaderClose = true,
}) {
  const [termsContent, setTermsContent] = useState(DEFAULT_TERMS_TEXT);

  useEffect(() => {
    if (!isOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose?.();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  useEffect(() => {
    if (!isOpen || children) return undefined;

    const controller = new AbortController();

    api.legal
      .terms({ signal: controller.signal })
      .then((terms) => {
        if (terms?.content) {
          setTermsContent(terms.content);
        }
      })
      .catch((requestError) => {
        if (requestError.name === "AbortError") return;
        setTermsContent(DEFAULT_TERMS_TEXT);
      });

    return () => controller.abort();
  }, [children, isOpen]);

  if (!isOpen) return null;

  const handleBackdropClick = (event) => {
    if (closeOnBackdrop && event.target === event.currentTarget) {
      onClose?.();
    }
  };

  const handleAccept = () => {
    onAccept?.();
  };

  const handleDeny = () => {
    onDeny?.();
  };

  return (
    <div
      className="terms-modal-backdrop"
      role="presentation"
      onMouseDown={handleBackdropClick}
    >
      <section
        className="terms-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="terms-modal-title"
      >
        <header className="terms-modal-header">
          <h2 id="terms-modal-title">{title}</h2>
          {showHeaderClose && (
            <button
              type="button"
              className="terms-modal-close"
              aria-label="Close terms and conditions"
              onClick={onClose}
            >
              &times;
            </button>
          )}
        </header>

        <div className="terms-modal-content">
          {children || (
            <pre className="terms-document terms-document-plain">
              {termsContent}
            </pre>
          )}
        </div>

        {showActions ? (
          <footer className="terms-modal-actions">
            <button
              type="button"
              className="terms-modal-button terms-modal-button-secondary"
              onClick={handleDeny}
            >
              {denyText}
            </button>
            <button
              type="button"
              className="terms-modal-button terms-modal-button-primary"
              onClick={handleAccept}
            >
              {acceptText}
            </button>
          </footer>
        ) : showCloseAction ? (
          <footer className="terms-modal-actions">
            <button
              type="button"
              className="terms-modal-button terms-modal-button-primary"
              onClick={onClose}
            >
              {closeText}
            </button>
          </footer>
        ) : null}
      </section>
    </div>
  );
}

export default TermsAndConditions;
